import { Box, Typography, Card, styled, SxProps } from "@mui/material";
import Colors from "../../theme/Colours";

export const FiltersSection = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  backgroundColor: Colors.background2,
  borderRadius: "4px 4px 0px 0px",
  padding: "16px",
  border: `0.96px solid ${Colors.filterBorder}`,
});

export const FiltersRight = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2,
});

export const ExportButton = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  padding: "8px 12px",
  border: `0.96px solid ${Colors.searchInputBorder}`,
  borderRadius: "4px",
  backgroundColor: Colors.background2,
  cursor: "pointer",
  transition: "background-color 0.2s ease",
  "&:hover": {
    backgroundColor: Colors.lightBackground,
  },
});

export const FilterExportText = styled(Typography)({
  fontSize: "13.46px",
  color: Colors.searchInputText,
  fontWeight: "500",
});

export const StyledCard = styled(Card)({
  borderRadius: "0px 0px 4px 4px",
  border: `0.96px solid ${Colors.filterBorder}`,
});

export const SummaryTitle = styled(Typography)({
  marginLeft: 24,
  fontWeight: 500,
  fontSize: "20px",
  color: Colors.searchInputText,
  fontFamily: "Poppins, sans-serif",
});

export const FooterText = styled(Typography)({
  color: Colors.borderGrey,
  fontFamily: "Poppins, sans-serif",
});

export const FooterContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  margin: 16,
});

export const orderPrice: SxProps = {
  fontSize: "11.63px",
  fontWeight: 600,
};

export const renderCell: SxProps = {
  display: "flex",
  flexDirection: "column",
};

export const orderStyle: SxProps = {
  fontSize: "10.66px",
};

export const evenRowColor = Colors.checkDetailsButton;
export const oddRowColor = Colors.background2;

export const colStyle: SxProps = {
  fontSize: "14px",
  color: Colors.greyTextColor,
};
